import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { GameError } from '@ezugi/types';

const initialState: GameError = {
  code: 0,
};

const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    set(_state, action: PayloadAction<GameError>) {
      return action.payload;
    },
    clear() {
      return initialState;
    },
  },
});

export const errorActions = errorSlice.actions;
export default errorSlice.reducer;
